import { Icon } from '@iconify/react';
import { isTribeEntity } from '@ipen-portal/ipen-entity-model';
import { makeEntityContentWithToolbar } from '@ipen-portal/plugin-layout-react';

export const ChapterListEntityContent = makeEntityContentWithToolbar({
  name: 'ChapterListEntityContent',
  params: {
    filter: isTribeEntity,
    icon: <Icon icon="material-symbols:list-alt-outline" />,
    loader: async () =>
      import('./components/ChapterList').then(m => <m.ChapterList />),
    path: '/chapters',

    title: 'Chapters',
    toolbarProps: {
      creationTemplateRef: 'ipen-chapter-template',
    },

    wrapperProps: {
      kindFilter: 'group',
      typeFilter: 'chapter',
    },
  },
});
